import { useLocation } from "react-router-dom";
import DeveloperCertificationLayout from "./developer_certification_layout.jsx";
import { CertificationContextProvider } from "./context/developer_certification_context.jsx";

const DeveloperCertificationPage = () => {
  const location = useLocation();
  const { environment } = location.state || {};

  return (
    <CertificationContextProvider environment={environment}>
      <DeveloperCertificationLayout />
    </CertificationContextProvider>
  );
};

export default DeveloperCertificationPage;
